import { Accordion as ChakraAccordion } from "@chakra-ui/react";
import { forwardRef } from "react";

export const AccordionRoot = forwardRef<HTMLDivElement, ChakraAccordion.RootProps>(function AccordionRoot(props, ref) {
  return <ChakraAccordion.Root ref={ref} {...props} />;
});

export const AccordionItem = ChakraAccordion.Item;
export const AccordionItemTrigger = ChakraAccordion.ItemTrigger;
export const AccordionItemContent = ChakraAccordion.ItemContent;
export const AccordionItemIndicator = ChakraAccordion.ItemIndicator;
